import { type InteractionChannelEnum } from '@/common/types/channel'
import { EntityFieldCodeEnum } from '@/common/types/fields'

export enum InteractionStatusEnum {
  OPEN = 'OPEN',
  REPLIED = 'REPLIED',
  BULKREPLIED = 'BULKREPLIED',
  FORWARDED = 'FORWARDED',
  NOACTIONREQUIRED = 'NOACTIONREQUIRED',
  COMPLETED = 'COMPLETED',
  DRAFT = 'DRAFT',
  TOSEND = 'TOSEND',
  TORESEND = 'TORESEND',
  SENT = 'SENT',
  SENDERROR = 'SENDERROR',
  TEMP = 'TEMP',
  TOBEVALIDATED = 'TOBEVALIDATED',
  MISSED = 'MISSED',
  UPDATED = 'UPDATED',
  DELETED = 'DELETED',
}
export type InteractionTypeDTOV1 = {
  code: InteractionTypeEnum
  direction: InteractionDirectionEnum
  channel: InteractionChannelEnum
  active: boolean
}
export const enum InteractionDirectionEnum {
  IN = 'IN',
  OUT = 'OUT',
}

export const enum InteractionTypeEnum {
  MAIL_IN = 'MAIL_IN',
  CALL_IN = 'CALL_IN',
  SMS_OUT_NOTIFICATION = 'SMS_OUT_NOTIFICATION',
  MAIL_OUT_ACKNOWLEDGEMENT = 'MAIL_OUT_ACKNOWLEDGEMENT',
  MAIL_OUT_USER_REPLY = 'MAIL_OUT_USER_REPLY',
  MAIL_OUT_USER_FORWARD = 'MAIL_OUT_USER_FORWARD',
  MAIL_OUT_USER_INITIATED = 'MAIL_OUT_USER_INITIATED',
  SATISFACTION_CONTACT = 'SATISFACTION_CONTACT',
  CALL_OUT = 'CALL_OUT',
  SMS_IN = 'SMS_IN',
  SMS_OUT = 'SMS_OUT',
  FB_IN_POST = 'FB_IN_POST',
  MAIL_OUT_BULK_USER_INITIATED = 'MAIL_OUT_BULK_USER_INITIATED',
  WHATSAPP_IN = 'WHATSAPP_IN',
  WHATSAPP_OUT = 'WHATSAPP_OUT',
  MAIL_OUT_NOTIFICATION = 'MAIL_OUT_NOTIFICATION',
  FB_OUT_POST = 'FB_OUT_POST',
  VISIT = 'VISIT',
  MISSED_OPPORTUNITY = 'MISSED_OPPORTUNITY',
  OPPORTUNITY = 'OPPORTUNITY',
  MAIL_OUT_TRANSCRIPT = 'MAIL_OUT_TRANSCRIPT',
  WHATSAPP_OUT_TEMPLATE = 'WHATSAPP_OUT_TEMPLATE',
  MAIL_IN_DISSUASION = 'MAIL_IN_DISSUASION',
  MAIL_OUT_DISSUASION = 'MAIL_OUT_DISSUASION',
  WHATSAPP_IN_DISSUASION = 'WHATSAPP_IN_DISSUASION',
  WHATSAPP_OUT_DISSUASION = 'WHATSAPP_OUT_DISSUASION',
  API_IN = 'API_IN',
  API_OUT = 'API_OUT',
  EXTERNAL = 'EXTERNAL',
}

export const InteractionCustomIcons = {
  NOTEBOOK: 'notebook',
  INBOX_OUT: 'inbox-out',
  INBOX_IN: 'inbox-in',
  MAILBOX_FLAG_UP: 'mailbox-flag-up',
  TYPEWRITER: 'typewriter',
  ENVELOPE_OPEN_TEXT: 'envelope-open-text',
  PEOPLE_GROUP: 'people-group',
  BUILDING: 'building',
  BRIEFCASE: 'briefcase',
  PEN_NIB: 'pen-nib',
  CALENDAR_DAYS: 'calendar-days',
  NETWORK_WIRED: 'network-wired',
  VIDEO: 'video',
  USB_DRIVE: 'usb-drive',
  FAX: 'fax',
  LAPTOP_ARROW_DOWN: 'laptop-arrow-down',
  MICROPHONE: 'microphone',
  WAVEFORM_LINES: 'waveform-lines',
  BOOK_OPEN_COVER: 'book-open-cover',
  ENVELOPES_BULK: 'envelopes-bulk',
  CIRCLE: 'circle',
  CLOUD: 'cloud',
  DIAMOND: 'diamond',
} as const

export type InteractionCustomIcon = (typeof InteractionCustomIcons)[keyof typeof InteractionCustomIcons]

export const enum InteractionModalType {
  CUSTOM = 'CUSTOM',
  API = 'API',
  STANDALONE = 'STANDALONE',
}

export enum InteractionIncludeEnum {
  HAS_ATTACHMENTS = 'HAS_ATTACHMENTS',
}

export enum InteractionExpandEnum {
  CUSTOM_FIELDS = 'CUSTOM_FIELDS',
}

export type InteractionAvailableIncludeOptions = keyof typeof InteractionIncludeEnum
export type InteractionAvailableExpandOptions = keyof typeof InteractionExpandEnum

export const EntityFieldInjectionMethods = {
  INCLUDE: 'INCLUDE',
  EXPAND: 'EXPAND',
} as const

export type InteractionFieldConfig = {
  includes?: Set<InteractionIncludeEnum>
  expands?: Set<InteractionExpandEnum>
}

export type InteractionFieldInjectionMethod<T> = T extends InteractionAvailableIncludeOptions
  ? (typeof EntityFieldInjectionMethods)['INCLUDE']
  : (typeof EntityFieldInjectionMethods)['EXPAND']

export type InteractionFieldInjectionOption<T extends InteractionAvailableIncludeOptions | InteractionAvailableExpandOptions> = {
  scope: T
  method: InteractionFieldInjectionMethod<T>
}

/**
 * Map of interaction fields added by an include and an expand
 */
export const InteractionFieldInjectionMap = new Map<
  EntityFieldCodeEnum,
  InteractionFieldInjectionOption<InteractionAvailableIncludeOptions> | InteractionFieldInjectionOption<InteractionAvailableExpandOptions>
>([[EntityFieldCodeEnum.INTERACTION_HAS_ATTACHMENTS, { scope: InteractionIncludeEnum.HAS_ATTACHMENTS, method: EntityFieldInjectionMethods.INCLUDE }]])
